import { path, sortBy, reverse, pathOr, prop, propOr, uniqBy } from 'ramda'

import * as R from 'ramda'

import { createSelector } from 'reselect'

import { BOARD_PATH, boardSelector } from './base'

const ID_PATH = [...BOARD_PATH, ':db/id']
const UUID_PATH = [...BOARD_PATH, ':board/squuid']
const SETTINGS_PATH = [...BOARD_PATH, ':board/settings']
const TITLE_PATH = [...BOARD_PATH, ':board/title']
const FEATURES_PATH = [...BOARD_PATH, ':board/features']
const TOPICS_PATH = [...BOARD_PATH, ':board/topics']
const GROUPS_PATH = [...BOARD_PATH, ':board/groups']
const BADGES_PATH = [...BOARD_PATH, ':board/badges']
// deprecated
const FOLLOWERS_PATH = [...BOARD_PATH, 'followers']
const SHARE_TOKENS_PATH = [...BOARD_PATH, ':board/share-tokens']
const TIMEZONE_PATH = [...BOARD_PATH, '@board/timezone']
const DISABLED_EMOJIS_PATH = [...BOARD_PATH, ':board/disabled-emojis']
const POST_QUERY_PATH = [...BOARD_PATH, 'postQuery']
const LTI_GRADES_PATH = [...BOARD_PATH, '@board/lti-grades']
const LTI_3_GRADES_PATH = [...BOARD_PATH, '@board/lti-3-grades']

export const boardIdSelector = path(ID_PATH)
export const boardUuidSelector = path(UUID_PATH)
export const boardSettingsSelector = path(SETTINGS_PATH)
export const titleSelector = path(TITLE_PATH)
const featuresSelector = pathOr([], FEATURES_PATH)
export const topicsSelector = pathOr([], TOPICS_PATH)
export const groupsSelector = pathOr([], GROUPS_PATH)
export const badgesSelector = pathOr([], BADGES_PATH)
const postQuerySelector = path(POST_QUERY_PATH)

export const followersSelector = pathOr([], FOLLOWERS_PATH)
export const shareTokensSelector = pathOr([], SHARE_TOKENS_PATH)
const ltiGradesSelector = pathOr([], LTI_GRADES_PATH)
const lti3GradesSelector = pathOr([], LTI_3_GRADES_PATH)

// STRIP DUPLICATE USERS FOR CASES LIKE UDEL WITH DIFF RESULT_SOURCEDIDS

const sortedLtiGradesSelector = createSelector(
  ltiGradesSelector,
  sortBy(propOr(0, ':lti-grade/last-grade-passed-at')),
  reverse
)

const sortedLti3GradesSelector = createSelector(
  lti3GradesSelector,
  sortBy(propOr(0, ':lti-3-grade/last-grade-passed-at')),
  reverse
)

export const uniqByUserLtiGradesSelector = createSelector(
  sortedLtiGradesSelector,
  uniqBy(path([':lti-grade/user', ':db/id']))
)

export const uniqByUserLti3GradesSelector = createSelector(
  sortedLti3GradesSelector,
  uniqBy(path([':lti-3-grade/user', ':db/id']))
)

export const boardTimezoneSelector = pathOr('America/New_York', TIMEZONE_PATH)

export const isBoardAdminSelector = createSelector(
  boardSelector,
  board => board.isBoardAdmin
)

export const featureEnabledFactory = featureKey =>
  createSelector(featuresSelector, features => features.includes(featureKey))

export const slateEditorEnabledSelector = featureEnabledFactory(':slate-editor')

export const disabledEmojisSelector = createSelector(
  pathOr('[]', DISABLED_EMOJIS_PATH),
  disabledEmojis => JSON.parse(disabledEmojis)
)

const flaggedPostCountSelector = createSelector(
  boardSelector,
  prop('flaggedPostCount')
)

export const hasFlaggedPostsSelector = createSelector(
  flaggedPostCountSelector,
  isBoardAdminSelector,
  (flaggedPostCount, isBoardAdmin) => isBoardAdmin || flaggedPostCount
)

export const hasCommentQuerySelector = createSelector(
  postQuerySelector,
  queryResult => queryResult && !!queryResult.id && !!queryResult.parent
)

export const commentQuerySelector = createSelector(
  postQuerySelector,
  hasCommentQuerySelector,
  (query, isCommentQuery) => isCommentQuery && prop('id', query)
)

const boardNetworkSelector = createSelector(
  boardSelector,
  prop(':board/network')
)

export const isDefaultBoardSelector = createSelector(
  boardSelector,
  boardNetworkSelector,
  (board, boardNetwork) =>
    board[':db/id'] &&
    board[':db/id'] === path([':network/default-board', ':db/id'], boardNetwork)
)

export const joinRequestCountSelector = createSelector(
  boardSelector,
  prop('@board/count-join-requests')
)

export const serviceUrlSelector = createSelector(
  boardSelector,
  prop(':board/service-url')
)

export const didTotalMembersSurpassCutoffSizeSelector = createSelector(
  boardSelector,
  R.prop('didTotalMembersSurpassCutoffSize')
)
